import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './login.js';
import SurveyComponent from './SurveyComponent';
import Callback from './callback.js';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login/>} />
        <Route path="/survey" element={<SurveyComponent />} />
        <Route path='/callback' element={<Callback/>}/>
      </Routes>
    </Router>
  );
}

export default App;
